import React, { useContext, useEffect, useState } from 'react';
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getProvidersForUser } from "root/DataFunctions/ProviderFns";
import useModalAddSchool, { AddSchoolModalMode } from "root/Modals/useModalAddSchool";
import TableProviderSchools from "root/Tables/TableProviderSchools";
import ContainerButton from "root/ContainerButton";
import GlobalContext from "root/Contexts/GlobalContext";

const SchoolsContainer = ( props ) =>
{
    const [renderModal, activateModal ] = useModalAddSchool() ;

    const [data, setData] = useState({loading: true, data: []});

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        getProvidersForUser( 'current', (response) =>
        {
            const returnData = getDataFromResponse(response) ;

            setData({loading: false, data: returnData})
        })
    }

    const onDialogClosed = (operation) =>
    {
        getData();
    }

    const onClickAddSchool = () =>
    {
        activateModal ( props.provider_id, onDialogClosed, AddSchoolModalMode.CREATE ) ;
    }

    const sessionContext = useContext( GlobalContext ) ;

    const survey_type = sessionContext.getCurrentSurveyType() ;

    return (

            <div className='container-for-tabs'>
                <TableProviderSchools data={data} survey_type={survey_type}/>
                <ContainerButton title='Add a new School' onClick={onClickAddSchool}/>
                {renderModal()}
            </div>

    )
}

export default SchoolsContainer;
